import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FpcConsultaFracaoPatrimonialComponent } from '../fpc-consulta-fracao-patrimonial/fpc-consulta-fracao-patrimonial.component';
import { FpcExtratoPreviComponent } from '../fpc-extrato-previ/fpc-extrato-previ.component';

const fpcRoutes = [
    { path: 'plano/fpcConsulta', component: FpcConsultaFracaoPatrimonialComponent },
    { path: 'plano/fpcExtrato', component: FpcExtratoPreviComponent }

];

@NgModule({
    imports: [RouterModule.forChild(fpcRoutes)],
    exports: [RouterModule]
})
export class FpcRoutingModule {


}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/planos/fpc/router/fpc.router.ts